/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    redirect: '/dashboard',
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/user-info',
                    name: 'user-info',
                    component: () => import('./views/pages/user/UserView.vue'),
                    meta: {
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/reset-password',
                    name: 'reset-password',
                    component: () => import('./views/pages/user/ResetPassword.vue'),
                    meta: {
                        rule: 'organization_user',
                    }
                },
                //Organization
                {
                    path: '/admin/reset-password',
                    name: 'admin-reset-password',
                    component: () => import('./views/admin-pages/reset-password/ResetPasswordAmin.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization',
                    name: 'manage-organization',
                    component: () => import('./views/admin-pages/organization/Organization'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization/add',
                    name: 'add-organization',
                    component: () => import('./views/admin-pages/organization/OrganizationInformation'),
                    meta: {
                        pageTitle: 'Thêm tổ chức',
                        parent: 'manage-organization',
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization/edit',
                    name: 'edit-organization',
                    component: () => import('./views/admin-pages/organization/OrganizationInformation'),
                    meta: {
                        pageTitle: 'Cập nhật tổ chức',
                        parent: 'manage-organization',
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-master-work-shift',
                    name: 'manage-master-work-shift',
                    component: () => import('./views/admin-pages/master-work-shift/WorkShift'),
                    meta: {
                        pageTitle: 'Cập nhật ca làm việc',
                        rule: 'admin',
                        parent: 'manage-master-work-shift'

                    }
                },
                {
                    path: '/user/register-organization-package',
                    name: 'register-organization-package',
                    component: () => import('./views/user-pages/user-package/UserPackage'),
                    meta: {
                        pageTitle: 'Đăng kí gói dịch vụ',
                        rule: 'organization',
                        parent: 'register-organization-package'
                    }
                },
                {
                    path: '/user/organization-package',
                    name: 'user-organization-package',
                    component: () => import('./views/user-pages/user-package/UserPackageInformation'),
                    meta: {
                        pageTitle: 'Gói đăng kí',
                        rule: 'organization'
                    }
                },
                {
                    path: '/user/history-register-organization-package',
                    name: 'history-register-organization-package',
                    component: () => import('./views/user-pages/user-package/UserRegisterPackageHistory'),
                    meta: {
                        pageTitle: 'Lich sử yêu cầu',
                        rule: 'organization',
                        parent: 'history-register-organization-package'
                    }
                },
                {
                    path: '/admin/history-register-package',
                    name: 'history-register-package',
                    component: () => import('./views/admin-pages/history-package/HistoryPackageHistory'),
                    meta: {
                        pageTitle: 'Lich sử yêu cầu',
                        rule: 'admin',
                        parent: 'history-register-package'
                    }
                },
                {
                    path: '/admin/organization-package',
                    name: 'organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackage'),
                    meta: {
                        pageTitle: 'Gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },
                {
                    path: '/admin/organization-package/add',
                    name: 'add-organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackageInformation'),
                    meta: {
                        pageTitle: 'Thêm gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },
                {
                    path: '/admin/organization-package/edit',
                    name: 'edit-organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackageInformation'),
                    meta: {
                        pageTitle: 'Sửa gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },

                // Permission
                {
                    path: '/user/manage-permission',
                    name: 'user-manage-permission',
                    component: () =>
                        import('./views/user-pages/permission/Permission'),
                    meta: {
                        pageTitle: 'Quản lý quyền hạn',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/add-permission',
                    name: 'user-add-permission',
                    component: () =>
                        import('./views/user-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Thêm mới quyền',
                        rule: 'organization_user',
                        parent: 'user-manage-permission'
                    }
                },
                {
                    path: '/user/edit-permission',
                    name: 'user-edit-permission',
                    component: () =>
                        import('./views/user-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Cập nhật quyền',
                        rule: 'organization_user',
                        parent: 'user-manage-permission'
                    }
                },

                {
                    path: '/admin/permission-function',
                    name: 'permission-function',
                    component: () => import('./views/admin-pages/permission/Permission'),
                    meta: {
                        pageTitle: 'Phân quyền chức năng',
                        rule: 'admin',
                        parent: 'permission-function'
                    }
                },
                {
                    path: '/admin/permission-function/add',
                    name: 'admin-permission-function',
                    component: () => import('./views/admin-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Thêm mới quyền chức năng',
                        rule: 'admin',
                        parent: 'permission-function'
                    }
                },
                {
                    path: '/admin/permission-function/edit',
                    name: 'admin-permission-function-edit',
                    component: () => import('./views/admin-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Sửa quyền chức năng',
                        rule: 'admin',
                        parent: 'admin-permission-function'
                    }
                },
                {
                    path: '/admin/manage-camera',
                    name: 'admin-manage-camera',
                    component: () => import('./views/admin-pages/camera/Camera'),
                    meta: {
                        pageTitle: 'Danh sách Camera',
                        rule: 'admin',
                        parent: 'admin-manage-camera'
                    }
                },

                // Role
                {
                    path: '/user/manage-position',
                    name: 'user-manage-position',
                    component: () =>
                        import('./views/user-pages/position/Position'),
                    meta: {
                        pageTitle: 'Quản lý chức vụ',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/application-for-leave',
                    name: 'user-application-for-leave',
                    component: () =>
                        import('./views/user-pages/applicatiFormLeave/Leave.vue'),
                    meta: {
                        pageTitle: 'Đơn xin nghỉ học sinh',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/create-application-for-leave',
                    name: 'user-create-application-for-leave',
                    component: () => import('./views/user-pages/applicatiFormLeave/LeaveInformation.vue'),
                    meta: {
                        pageTitle: 'Tạo mới đơn xin nghỉ',
                        rule: 'organization_user',
                        parent: 'user-manage-leave'
                    }
                },

                {
                    path: '/user/edit-leave',
                    name: 'user-edit-leave',
                    component: () => import('./views/user-pages/applicatiFormLeave/LeaveInformation.vue'),
                    meta: {
                        pageTitle: 'Cập nhật đơn xin nghỉ',
                        rule: 'organization_user',
                        parent: 'user-manage-leave'
                    }
                },
                {
                    path: '/user/add-position',
                    name: 'user-add-position',
                    component: () =>
                        import('./views/user-pages/position/PositionInfomation'),
                    meta: {
                        pageTitle: 'Thêm mới chức vụ',
                        rule: 'organization_user',
                        parent: 'user-manage-position'
                    }
                },
                {
                    path: '/user/edit-position',
                    name: 'user-edit-position',
                    component: () =>
                        import('./views/user-pages/position/PositionInfomation'),
                    meta: {
                        pageTitle: 'Cập nhật chức vụ',
                        rule: 'organization_user',
                        parent: 'user-manage-position'
                    }
                },

                {
                    path: '/admin/edit-camera',
                    name: 'edit-admin-manage-camera',
                    component: () => import('./views/admin-pages/camera/CameraInformation'),
                    meta: {
                        pageTitle: 'Cập nhật Camera',
                        rule: 'admin',
                        parent: 'admin-manage-camera'
                    }
                },
                {
                    path: '/user/organization-info',
                    name: 'user-organization-info',
                    component: () => import('./views/user-pages/organization/Organization'),
                    meta: {
                        pageTitle: 'Thông tin tổ chức',
                        rule: 'organization_user'
                    }
                },
                //Branch
                {
                    path: '/user/organization-branch',
                    name: 'user-organization-branch',
                    component: () => import('./views/user-pages/branch/Branch'),
                    meta: {
                        pageTitle: 'Danh sách chi nhánh',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/add-organization-branch',
                    name: 'user-add-organization-branch',
                    component: () => import('./views/user-pages/branch/BranchInformation'),
                    meta: {
                        pageTitle: 'Thêm chi nhánh',
                        parent: 'user-organization-branch',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/edit-organization-branch',
                    name: 'user-edit-organization-branch',
                    component: () => import('./views/user-pages/branch/BranchInformation'),
                    meta: {
                        pageTitle: 'Cập nhật chi nhánh',
                        parent: 'user-organization-branch',
                        rule: 'organization_user'
                    }
                },

                //Device
                {
                    path: '/user/manage-device',
                    name: 'user-manage-device',
                    component: () => import('./views/user-pages/device/Device'),
                    meta: {
                        pageTitle: 'Danh sách tài sản',
                        rule: 'organization_user',
                        parent: 'manage-device'
                    }
                },
                {
                    path: '/user/add-device',
                    name: 'user-add-device',
                    component: () => import('./views/user-pages/device/DeviceInformation'),
                    meta: {
                        pageTitle: 'Thêm tài sản',
                        parent: 'manage-device',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/edit-device',
                    name: 'user-edit-device',
                    component: () => import('./views/user-pages/device/DeviceInformation'),
                    meta: {
                        pageTitle: 'Cập nhật tài sản',
                        parent: 'manage-device',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/assign-device-history',
                    name: 'user-assign-device-history',
                    component: () => import('./views/user-pages/device/AssignDeviceHistory'),
                    meta: {
                        pageTitle: 'Lịch sử tài sản',
                        rule: 'organization_user',
                        parent: 'user-assign-device-history'
                    }
                },
                {
                    path: '/user/assign-device',
                    name: 'user-assign-device',
                    component: () => import('./views/user-pages/device/AssignDeviceInformation'),
                    meta: {
                        pageTitle: 'Cấp phát tài sản',
                        rule: 'organization_user',
                        parent: 'manage-device'
                    }
                },
                // Equipment
                {
                    path: '/user/manage-equipment',
                    name: 'user-manage-equipment',
                    component: () => import('./views/user-pages/equipment/Equipment'),
                    meta: {
                        pageTitle: 'Danh sách vật dụng',
                        rule: 'organization_user',
                        parent: 'manage-equipment'
                    }
                },
                {
                    path: '/user/add-equipment',
                    name: 'user-add-equipment',
                    component: () => import('./views/user-pages/equipment/EquipmentInformation'),
                    meta: {
                        pageTitle: 'Thêm vật dụng',
                        parent: 'manage-equipment',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/edit-equipment',
                    name: 'user-edit-equipment',
                    component: () => import('./views/user-pages/equipment/EquipmentInformation'),
                    meta: {
                        pageTitle: 'Cập nhật vật dụng',
                        parent: 'manage-equipment',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/assign-equipment-history',
                    name: 'user-assign-equipment-history',
                    component: () => import('./views/user-pages/equipment/AssignEquipmentHistory'),
                    meta: {
                        pageTitle: 'Lịch sử vật dụng',
                        rule: 'organization_user'
                    }
                },

                {
                    path: '/user/assigned-equipment',
                    name: 'user-assigned-equipment',
                    component: () => import('./views/user-pages/equipment/AssignedEquipment'),
                    meta: {
                        pageTitle: 'Cấp phát vật dụng',
                        rule: 'organization_user',
                        parent: 'manage-equipment'
                    }
                },

                {
                    path: '/user/assign-equipment',
                    name: 'user-assign-equipment',
                    component: () => import('./views/user-pages/equipment/AssignEquipmentInformation'),
                    meta: {
                        pageTitle: 'Thông tin tài sản',
                        rule: 'organization_user',
                        parent: 'manage-equipment'
                    }
                },
                {
                    path: '/user/customer',
                    name: 'user-customer',
                    component: () => import('./views/user-pages/customer/Customer'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/add-customer',
                    name: 'user-add-customer',
                    component: () => import('./views/user-pages/customer/CustomerInformation'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-customer'
                    }
                },
                {
                    path: '/user/edit-customer',
                    name: 'user-edit-customer',
                    component: () => import('./views/user-pages/customer/CustomerInformation'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-customer'
                    }
                },
                //Multipurpose-Room
                {
                    path: '/user/manage-multipurpose-room',
                    name: 'user-manage-manage-multipurpose-room',
                    component: () => import('./views/user-pages/multipurpose-room/MultipurposeRoom'),
                    meta: {
                        pageTitle: 'Lịch phòng họp',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/manage-meeting-room',
                    name: 'user-manage-meeting-room',
                    component: () => import('./views/user-pages/multipurpose-room/MeetingRoom'),
                    meta: {
                        pageTitle: 'Phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room'
                    }
                },
                {
                    path: '/user/add-meeting-room',
                    name: 'user-add-meeting-room',
                    component: () => import('./views/user-pages/multipurpose-room/MeetingRoomInformation'),
                    meta: {
                        pageTitle: 'Thêm phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room'
                    }
                },
                {
                    path: '/user/edit-meeting-room',
                    name: 'user-edit-meeting-room',
                    component: () => import('./views/user-pages/multipurpose-room/MeetingRoomInformation'),
                    meta: {
                        pageTitle: 'Cập nhật phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room'
                    }
                },
                {
                    path: '/user/meeting-schedule',
                    name: 'user-meeting-schedule',
                    component: () => import('./views/user-pages/multipurpose-room/MeetingSchedule'),
                    meta: {
                        pageTitle: 'Lịch họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room'
                    }
                },
                {
                    path: '/user/book-a-meeting',
                    name: 'user-book-a-meeting',
                    component: () => import('./views/user-pages/multipurpose-room/BookAMeetingInformation'),
                    meta: {
                        pageTitle: 'Đặt lịch họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room'
                    }
                },

                // Report
                {
                    path: '/user/manage-stranger',
                    name: 'manage-report-stranger',
                    component: () => import('./views/user-pages/report/ReportStranger'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                // Report Tu Tập
                {
                    path: '/user/manage-crowded',
                    name: 'manage-report-crowded',
                    component: () => import('./views/user-pages/report/ReportCrowded'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                // Report Tụ Tập Detail
                {
                    path: '/user/detail-crowded',
                    name: 'detail-report-crowded',
                    component: () => import('./views/user-pages/report/ReportCrowdedDetail'),
                    meta: {
                        pageTitle: 'Thông tin chi tiết tụ tập',
                        rule: 'organization_user',
                        parent: 'manage-report-crowded'
                    }
                },
                //Camera Report
                {
                    path: '/user/manage-stranger/show',
                    name: 'show-camera-stranger',
                    component: () => import('./views/user-pages/report/ReportRealTime'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'manage-report-stranger'
                    }
                },
                //Report Detail
                {
                    path: '/user/detail-stranger/',
                    name: 'detail-report-stranger',
                    component: () => import('./views/user-pages/report/ReportStrangerDetail'),
                    meta: {
                        pageTitle: 'Thông tin xâm nhập',
                        rule: 'organization_user',
                        parent: 'manage-report-stranger'
                    }
                },
                //Wifi
                {
                    path: '/user/manage-wifi',
                    name: 'user-manage-wifi',
                    component: () => import('./views/user-pages/wifi/Wifi'),
                    meta: {
                        pageTitle: 'Danh sách wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi'
                    }
                },
                {
                    path: '/user/add-wifi',
                    name: 'user-add-wifi',
                    component: () => import('./views/user-pages/wifi/WifiInformation'),
                    meta: {
                        pageTitle: 'Thêm wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi'
                    }
                },
                {
                    path: '/user/edit-wifi',
                    name: 'user-edit-wifi',
                    component: () => import('./views/user-pages/wifi/WifiInformation'),
                    meta: {
                        pageTitle: 'Cập nhật wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi'
                    }
                },

                //QR-Code
                // {
                //     path: '/user/manage-qr-code',
                //     name: 'user-manage-qr-code',
                //     component: () => import('./views/user-pages/qr-code/QRCodeCheckIn'),
                //     meta: {
                //         rule: 'organization',
                //         pageTitle: 'Danh sách QR Code',
                //         parent: 'user-manage-qr-code'
                //     }
                // },
                // {
                //     path: '/user/add-qr-code',
                //     name: 'user-add-qr-code',
                //     component: () => import('./views/user-pages/qr-code/QRCodeInformation'),
                //     meta: {
                //         pageTitle: 'Thêm mới mã QR',
                //         rule: 'organization',
                //         parent: 'user-manage-qr-code'
                //     }
                // },
                // {
                //     path: '/user/edit-qr-code',
                //     name: 'user-edit-qr-code',
                //     component: () => import('./views/user-pages/qr-code/QRCodeInformation'),
                //     meta: {
                //         pageTitle: 'Cập nhật mã QR',
                //         rule: 'organization',
                //         parent: 'user-manage-qr-code'
                //     }
                // },
                //News
                {
                    path: '/user/manage-news',
                    name: 'user-manage-news',
                    component: () => import('./views/user-pages/news/News'),
                    meta: {
                        pageTitle: 'Danh sách bảng tin',
                        rule: 'organization_user',
                        parent: 'user-manage-news'
                    }
                },
                {
                    path: '/user/add-news',
                    name: 'user-add-news',
                    component: () => import('./views/user-pages/news/NewsInformation'),
                    meta: {
                        pageTitle: 'Thêm bảng tin',
                        rule: 'organization_user',
                        parent: 'user-manage-news'
                    }
                },
                {
                    path: '/user/edit-news',
                    name: 'user-edit-news',
                    component: () => import('./views/user-pages/news/NewsInformation'),
                    meta: {
                        pageTitle: 'Cập nhật bảng tin',
                        rule: 'organization_user',
                        parent: 'user-manage-news'
                    }
                },
                {
                    path: '/user/evaluate-news',
                    name: 'user-evaluate-news',
                    component: () => import('./views/user-pages/news/Evaluate'),
                    meta: {
                        pageTitle: 'Đánh giá',
                        rule: 'organization_user',
                        parent: 'user-manage-news'
                    }
                },
                {
                    path: '/user/selection-news',
                    name: 'user-selection-news',
                    component: () => import('./views/user-pages/news/Selection'),
                    meta: {
                        pageTitle: 'Đánh giá',
                        rule: 'organization_user',
                        parent: 'user-manage-news'
                    }
                },
                //Notification
                {
                    path: '/user/manage-notification',
                    name: 'user-manage-notification',
                    component: () => import('./views/user-pages/notification/Notification'),
                    meta: {
                        pageTitle: 'Danh sách thông báo',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/add-notification',
                    name: 'user-add-notification',
                    component: () => import('./views/user-pages/notification/NotificationInformation'),
                    meta: {
                        pageTitle: 'Thêm thông báo',
                        rule: 'organization_user',
                        parent: 'user-manage-notification'
                    }
                },
                {
                    path: '/user/edit-notification',
                    name: 'user-edit-notification',
                    component: () => import('./views/user-pages/notification/NotificationInformation'),
                    meta: {
                        pageTitle: 'Cập nhật thông báo',
                        rule: 'organization_user',
                        parent: 'user-manage-notification'
                    }
                },
                //classroomManager
                {
                    path: '/user/manage-classroom-manager',
                    name: 'user-manage-classroom-manager',
                    component: () => import('./views/user-pages/internal-communication/ClassroomManage'),
                    meta: {
                        pageTitle: 'Danh sách lớp quản lí',
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/manage-add-classroom-manager',
                    name: 'user-manage-add-classroom-manager',
                    component: () => import('./views/user-pages/internal-communication/ClassroomManagerInformation'),
                    meta: {
                        pageTitle: 'Thêm mới lớp quản lí',
                        rule: 'organization_user',
                        parent: 'user-manage-classroom-manager',
                    }
                },
                {
                    path: '/user/manage-edit-classroom-manager',
                    name: 'user-manage-edit-classroom-manager',
                    component: () => import('./views/user-pages/internal-communication/ClassroomManagerInformation'),
                    meta: {
                        pageTitle: 'Chi tiết lớp quản lí',
                        rule: 'organization_user',
                        parent: 'user-manage-classroom-manager',
                    }
                },
  
               

                // {
                //     path: '/user/manage-work-shift-branch',
                //     name: 'manage-work-shift-branch',
                //     component: () => import('./views/user-pages/workshift/OrganizationBranchWorkShift'),
                //     meta: {
                //         pageTitle: 'Danh sách ca làm việc',
                //         rule: 'organization'
                //     }
                // },
                //WorkShift
                {
                    path: '/admin/edit-master-work-shift',
                    name: 'edit-master-work -shift',
                    component: () => import('./views/admin-pages/master-work-shift/WorkShiftInformation'),
                    meta: {
                        rule: 'admin',
                        pageTitle: 'Cập nhật ca làm việc',
                        parent: 'manage-master-work-shift'

                    }
                },
                {
                    path: '/user/manage-work-shift',
                    name: 'manage-work-shift',
                    component: () => import('./views/user-pages/workshift/WorkShift'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/manage-branch-work-shift',
                    name: 'manage-branch-work-shift',
                    component: () => import('./views/user-pages/workshift/OrganizationBranchWorkShift'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift'
                    }
                },
                {
                    path: '/user/add-work-shift',
                    name: 'user-add-work-shift',
                    component: () => import('./views/user-pages/workshift/WorkShiftInformation'),
                    meta: {
                        pageTitle: 'Thêm ca làm việc',
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift'
                    }
                },
                {
                    path: '/user/edit-work-shift',
                    name: 'edit-add-work-shift',
                    component: () => import('./views/user-pages/workshift/WorkShiftInformation'),
                    meta: {
                        pageTitle: 'Cập nhật ca làm việc',
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift'
                    }
                },

                {
                    path: '/user/manage-employee',
                    name: 'user-manage-employee',
                    component: () => import('./views/user-pages/employee/Employee'),
                    meta: {
                        pageTitle: 'Danh sách nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee'
                    }
                },
                {
                    path: '/user/add-employee',
                    name: 'user-add-employee',
                    component: () => import('./views/user-pages/employee/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Thêm nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee'
                    }
                },
                {
                    path: '/user/edit-employee',
                    name: 'user-edit-employee',
                    component: () => import('./views/user-pages/employee/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Cập nhật nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee'
                    }
                },

                // {
                //     path: '/user/manage-work-shift-by-day',
                //     name: 'manage-work-shift-by-day',
                //     component: () => import('./views/user-pages/workshiftbyday/Employee'),
                //     meta: {
                //         pageTitle: 'Nhân sự làm việc theo ngày',
                //         rule: 'organization'
                //     }
                // },
                // {
                //     path: '/user/setting-work-shift-by-day',
                //     name: 'user-setting-work-shift-by-day',
                //     component: () => import('./views/user-pages/workshiftbyday/SettingWorkShiftByDay'),
                //     meta: {
                //         pageTitle: 'Ca làm việc theo ngày',
                //         rule: 'organization',
                //         parent: 'manage-work-shift-by-day'
                //     }
                // },
                {
                    path: '/user/in-out-history',
                    name: 'user-in-out-history',
                    component: () => import('./views/user-pages/in-out-history/InOutHistory'),
                    meta: {
                        pageTitle: 'Lịch sử ra vào',
                        rule: 'organization_user',
                        parent: 'user-in-out-history'
                    }
                },
                {
                    path: '/user/manage-work-shift-branch',
                    name: 'manage-work-shift-branch',
                    component: () => import('./views/user-pages/workshift/OrganizationBranchWorkShift'),
                    meta: {
                        pageTitle: 'Danh sách ca làm việc',
                        rule: 'organization_user',
                    }
                },
                // {
                //   path: '/user/confirm-time-keeping',
                //   name: 'confirm-time-keeping',
                //   component: () => import('./views/user-pages/confirmTimeKeeping/ConfirmTimeKeeping'),
                //   meta: {
                //     pageTitle: 'Xác nhận chấm công',
                //     rule: 'organization'
                //   }
                // },
                {
                    path: '/user/update-in-out',
                    name: 'update-in-out',
                    component: () => import('./views/user-pages/update-in-out/UpdateInOut'),
                    meta: {
                        pageTitle: 'Danh sách khiếu nại',
                        rule: 'organization_user',
                        parent: 'update-in-out'
                    }
                },
                {
                    path: '/user/update-in-out-by-id',
                    name: 'update-in-out-by-id',
                    component: () => import('./views/user-pages/update-in-out/InOutInformation'),
                    meta: {
                        pageTitle: 'Tạo đơn khiếu nại',
                        rule: 'organization_user',
                        parent: 'update-in-out'
                    }
                },
                // {
                //     path: '/user/in-out-history-customer',
                //     name: 'user-in-out-history-customer',
                //     component: () => import('./views/user-pages/in-out-history-customer/InOutHistoryCustomer'),
                //     meta: {
                //         rule: 'organization'
                //     }
                // },
                // {
                //     path: '/user/in-out-history-customer-realtime',
                //     name: 'user-in-out-history-customer-realtime',
                //     component: () => import('./views/user-pages/in-out-history-customer/InOutHistoryCustomerRealtime'),
                //     meta: {
                //         rule: 'organization'
                //     }
                // },
                {
                    path: '/user/time-keeping',
                    name: 'time-keeping',
                    component: () => import('./views/user-pages/time-keeping/Employee'),
                    meta: {
                        pageTitle: 'Lịch sử chấm công',
                        rule: 'organization_user',
                        parent: 'time-keeping'
                    }
                },
                {
                    path: '/user/time-keeping-detail',
                    name: 'time-keeping-detail',
                    component: () => import('./views/user-pages/time-keeping/TimeKeepingDetail'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'time-keeping'
                    }
                },
                {
                    path: '/user/time-keeping-teacher',
                    name: 'time-keeping-teacher',
                    component: () => import('./views/user-pages/time-keeping-teacher/Employee'),
                    meta: {
                        pageTitle: 'Lịch sử chấm công',
                        rule: 'organization_user',
                        parent: 'time-keeping-teacher'
                    }
                },
                {
                    path: '/user/time-keeping-teacher-detail',
                    name: 'time-keeping-teacher-detail',
                    component: () => import('./views/user-pages/time-keeping-teacher/TimeKeepingDetail'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'time-keeping-teacher'
                    }
                },
                {
                    path: '/user/attendance',
                    name: 'attendance',
                    component: () => import('./views/user-pages/attendance/Attendance'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'attendance'
                    }
                },
                {
                    path: '/user/student-in-out-history',
                    name: 'user-student-in-out-history',
                    component: () => import('./views/user-pages/in-out-history/InOutHistoryStudent'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'attendance'
                    }
                },
                {
                    path: '/login',
                    name: 'login',
                    redirect: '/pages/login',
                },
                // Plate list
                {
                    path: '/user/place',
                    name: 'place',
                    component: () => import('./views/user-pages/daily-work/Place'),
                    meta: {
                        rule: 'organization_user'
                    }
                },

                // Add place
                {
                    path: '/user/add-place',
                    name: 'add-place',
                    component: () => import('./views/user-pages/daily-work/PlaceInformation'),
                    meta: {
                        pageTitle: "Thêm địa điểm",
                        rule: 'organization_user'
                    }
                },
                // Add place
                {
                    path: '/user/edit-place',
                    name: 'edit-place',
                    component: () => import('./views/user-pages/daily-work/PlaceInformation'),
                    meta: {
                        pageTitle: "Cập nhật địa điểm",
                        rule: 'organization_user'
                    }
                },
                // Area
                {
                    path: '/user/area',
                    name: 'area',
                    component: () => import('./views/user-pages/daily-work/Area.vue'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                // Add Area
                {
                    path: '/user/add-area',
                    name: 'add-area',
                    component: () => import('./views/user-pages/daily-work/AreaInformation.vue'),
                    meta: {
                        pageTitle: "Thêm Khu vực kiểm tra",
                        rule: 'organization_user'
                    }
                },
                // edit Area
                {
                    path: '/user/edit-area',
                    name: 'edit-area',
                    component: () => import('./views/user-pages/daily-work/AreaInformation.vue'),
                    meta: {
                        pageTitle: "Cập nhật khu vực kiểm tra",
                        rule: 'organization_user'
                    }
                },
                // Daily Work
                {
                    path: '/user/manage-branch-daily-work',
                    name: 'manage-branch-daily-work',
                    component: () => import('./views/user-pages/daily-work/OrganizationBranchDailyWork'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                // Daily Work Detail
                {
                    path: '/user/daily-work-detail',
                    name: 'daily-work-detail',
                    component: () => import('./views/user-pages/daily-work/DailyWorkDetail'),
                    meta: {
                        rule: 'organization_user'
                    }
                },
                // Daily Work Detail Information
                {
                    path: '/user/add-daily-work-detail',
                    name: 'add-daily-work-detail',
                    component: () => import('./views/user-pages/daily-work/DailyWorkDetailInformation'),
                    meta: {
                        pageTitle: "Thêm hạng mục kiểm tra",
                        rule: 'organization_user'
                    }
                },
                // Daily Work Detail Information
                {
                    path: '/user/edit-daily-work-detail',
                    name: 'edit-daily-work-detail',
                    component: () => import('./views/user-pages/daily-work/DailyWorkDetailInformation'),
                    meta: {
                        pageTitle: 'Cập nhật hạng mục',
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/add-daily-work',
                    name: 'user-add-daily-work',
                    component: () => import('./views/user-pages/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Thêm công việc hàng ngày',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/edit-daily-work',
                    name: 'user-edit-daily-work',
                    component: () => import('./views/user-pages/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Cập nhật công việc hàng ngày',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/manage-daily-work-by-day',
                    name: 'manage-work-shift-by-day',
                    component: () => import('./views/user-pages/workshiftbyday/Employee'),
                    meta: {
                        pageTitle: 'Nhân sự làm việc theo ngày',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/daily-work-result',
                    name: 'daily-work-result',
                    component: () => import('./views/user-pages/dailywork-result/Employee'),
                    meta: {
                        pageTitle: 'Giao việc thủ công',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/add-daily-work',
                    name: 'add-daily-work',
                    component: () => import('./views/user-pages/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Thêm công việc mới',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/edit-daily-work',
                    name: 'edit-daily-work',
                    component: () => import('./views/user-pages/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Cập nhật công việc',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/register-daily-work',
                    name: 'manage-employee-daily-work',
                    component: () => import('./views/user-pages/daily-work/Employee'),
                    meta: {
                        pageTitle: 'Đăng ký công việc hàng ngày',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/register-employee-daily-work',
                    name: 'register-employee-daily-work',
                    component: () => import('./views/user-pages/daily-work/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Đăng ký công việc hàng ngày',
                        rule: 'organization_user'
                    }
                },
                {
                    path: '/user/manage-daily-work-branch',
                    name: 'manage-daily-work-branch',
                    component: () => import('./views/user-pages/daily-work/DailyWork'),
                    meta: {
                        pageTitle: 'Ca làm việc theo ngày',
                        rule: 'organization_user',
                        parent: 'manage-work-shift-by-day'
                    }
                },
                // {
                //     path: '/user/over-time-manager',
                //     name: 'user-over-time-manager',
                //     component: () => import('./views/user-pages/over-time/Overtime.vue'),
                //     meta: {
                //         pageTitle: 'Ca làm thêm',
                //         rule: 'organization',
                //         parent: 'user-over-time-manager'
                //     }
                // },
                // {
                //     path: '/user/over-time',
                //     name: 'user-over-time',
                //     component: () => import('./views/user-pages/over-time/OvertimeInfomation.vue'),
                //     meta: {
                //         pageTitle: 'Ca làm thêm',
                //         rule: 'organization',
                //         parent: 'user-over-time-manager'
                //     }
                // },{
                //     path: '/user/over-time-manager',
                //     name: 'user-over-time-manager',
                //     component: () => import('./views/user-pages/over-time/Overtime.vue'),
                //     meta: {
                //         pageTitle: 'Ca làm thêm',
                //         rule: 'organization',
                //         parent: 'user-over-time-manager'
                //     }
                // },
                {
                    path: '/user/over-time',
                    name: 'user-over-time',
                    component: () => import('./views/user-pages/over-time/OvertimeInfomation.vue'),
                    meta: {
                        pageTitle: 'Ca làm thêm',
                        rule: 'organization_user',
                        parent: 'user-over-time-manager'
                    }
                },
                {
                    path: '/user/schedule',
                    name: 'user-schedule',
                    component: () => import('./views/user-pages/school-schedule/SchoolSchedule.vue'),
                    meta: {
                        pageTitle: 'Lịch học',
                        rule: 'organization_user',
                        parent: 'user-schedule'
                    }
                },
                {
                    path: '/user/schedule-staff',
                    name: 'user-schedule-staff',
                    component: () => import('./views/user-pages/school-schedule/EmployeeSchedule.vue'),
                    meta: {
                        pageTitle: 'Lịch học',
                        rule: 'organization_user',
                        parent: 'user-schedule-staff'
                    }
                },
                // Class
                {
                    path: '/user/manage-class',
                    name: 'user-manage-class',
                    component: () => import('./views/user-pages/class/ClassManage.vue'),
                    meta: {
                        pageTitle: 'Quản lý học sinh',
                        rule: 'organization_user',
                        parent: 'user-manage-class'
                    }
                },
                {
                    path: '/user/class-info',
                    name: 'user-class-info',
                    component: () => import('./views/user-pages/class/ClassInfo.vue'),
                    meta: {
                        pageTitle: 'Thông tin học sinh',
                        rule: 'organization_user',
                        parent: 'user-manage-class'
                    }
                },
                {
                    path: '/user/class-edit',
                    name: 'user-class-edit',
                    component: () => import('./views/user-pages/class/ClassInfo.vue'),
                    meta: {
                        pageTitle: 'Thông tin học sinh',
                        rule: 'organization_user',
                        parent: 'user-manage-class'
                    }
                },
                {
                    path: '/user/work-shift-school',
                    name: 'user-school',
                    component: () => import('./views/user-pages/work-shift-school/WorkShiftSchool.vue'),
                    meta: {
                        pageTitle: 'Ca làm việc',
                        rule: 'organization_user',
                        parent: 'user-school'
                    }
                },
                {
                    path: '/user/student',
                    name: 'user-student',
                    component: () => import('./views/user-pages/student/StudentManager.vue'),
                    meta: {
                        pageTitle: 'Học sinh',
                        rule: 'organization_user',
                        parent: 'user-student'
                    }
                },
                {
                    path: '/user/student-infomation',
                    name: 'user-student-info',
                    component: () => import('./views/user-pages/student/StudentInfomation.vue'),
                    meta: {
                        pageTitle: 'Học sinh',
                        rule: 'organization_user',
                        parent: 'user-student'
                    }
                },

                //Library
                //Category
                {
                    path: '/user/manage-category',
                    name: 'manage-catelory',
                    component: () => import('./views/user-pages/library/category/ManageCategory'),
                    meta: {
                        pageTitle: 'Danh mục',
                        rule: 'organization_user',
                        parent: 'manage-category'
                    }
                },
                {
                    path: '/user/details-category',
                    name: 'details-category',
                    component: () => import('./views/user-pages/library/category/DetailsCategory'),
                    meta: {
                        pageTitle: 'Chi tiết danh mục',
                        rule: 'organization_user',
                        parent: 'manage-category'
                    }
                },
                //Book
                {
                    path: '/user/manage-book',
                    name: 'manage-book',
                    component: () => import('./views/user-pages/library/book/ManageBook'),
                    meta: {
                        pageTitle: 'Sách',
                        rule: 'organization_user',
                        parent: 'manage-book'
                    }
                },
                {
                    path: '/user/details-book',
                    name: 'details-book',
                    component: () => import('./views/user-pages/library/book/DetailsBook'),
                    meta: {
                        pageTitle: 'Chi tiết sách',
                        rule: 'organization_user',
                        parent: 'manage-book'
                    }
                },
                //Document
                {
                    path: '/user/document',
                    name: 'document',
                    component: () => import('./views/user-pages/document/Document'),
                    meta: {
                        pageTitle: 'Tài liệu',
                        rule: 'organization_user',
                        parent: 'document'
                    }
                },
                //Config
                {
                    path: '/config/classtime',
                    name: 'config-classtime',
                    component: () => import('./views/user-pages/class-time/ClassTime.vue'),
                    meta: {
                        pageTitle: 'Thời gian lên lớp',
                        rule: 'organization_user',
                        parent: 'config-classtime'
                    }
                },
                //Badges
                {
                    path: '/user/badges',
                    name: 'user-badges',
                    component: () => import('./views/user-pages/badges/Badges'),
                    meta: {
                        pageTitle: 'Huy hiệu',
                        rule: 'organization_user',
                        parent: 'user-badges'
                    }
                },
                //Invoice
                {
                    path: '/user/manage-receipts',
                    name: 'manage-receipts',
                    component: () => import('./views/user-pages/invoice/ReceiptsManage'),
                    meta: {
                        pageTitle: 'Phiếu thu',
                        rule: 'organization_user',
                        // parent: 'manage-receipts'
                    }
                },
                {
                    path: '/user/manage-payroll',
                    name: 'manage-payroll',
                    component: () => import('./views/user-pages/invoice/TeacherSalarySchedule.vue'),
                    meta: {
                        pageTitle: 'Báo cáo tiết dạy',
                        rule: 'organization_user',
                        parent: 'manage-payroll'
                    }
                },
                {
                    path: '/user/details-receipts',
                    name: 'details-receipts',
                    component: () => import('./views/user-pages/invoice/ReceiptsDetails'),
                    meta: {
                        pageTitle: 'Chi tiết Phiếu thu',
                        rule: 'organization_user',
                        parent: 'manage-receipts'
                    }
                },
                //Client
                {
                    path: '/user/manage-school',
                    name: 'user-manage-school',
                    component: () => import('./views/user-pages/branch/School'),
                    meta: {
                        pageTitle: 'Trường',
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/details-client',
                    name: 'details-client',
                    component: () => import('./views/user-pages/branch/SchoolInfomation'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-client'
                    }
                },

                //Department
                {
                    path: '/user/manage-department',
                    name: 'user-manage-department',
                    component: () => import('./views/user-pages/department/Department'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-department'
                    }
                },
                {
                    path: '/user/department-info',
                    name: 'user-department-info',
                    component: () => import('./views/user-pages/department/DepartmentInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-department'
                    }
                },

                // Notification Class
                {
                    path: '/user/teacher-interaction',
                    name: 'user-teacher-interaction',
                    component: () => import('./views/user-pages/teacher-interaction/TeacherInteraction'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-teacher-interaction'
                    }
                },

                {
                    path: '/user/teacher-interaction-info',
                    name: 'user-teacher-interaction-info',
                    component: () => import('./views/user-pages/teacher-interaction/TeacherInteractionInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-teacher-interaction'
                    }
                },

                //questions
                {
                    path: '/user/multiple-choice-exercises',
                    name: 'multiple-choice-exercises',
                    component: () => import('./views/user-pages/homework/MultipleChoiceExercises.vue'),
                    meta: {
                        rule: 'organization_user',
                        // parent: 'user-multiple-choice-exercises'
                    }
                },
                {
                    path: '/user/multiple-choice-exercises-history',
                    name: 'multiple-choice-exercises-history',
                    component: () => import('./views/user-pages/homework/HistoryExam.vue'),
                    meta: {
                        rule: 'organization_user',
                        // parent: 'user-multiple-choice-exercises'
                    }
                },
                {
                    path: '/user/student-work-history',
                    name: 'student-work-history',
                    component: () => import('./views/user-pages/homework/StudentWorkHistory.vue'),
                    meta: {
                        rule: 'organization_user',
                        // parent: 'user-multiple-choice-exercises'
                    }
                },
                
                {
                    path: '/user/multiple-category',
                    name: 'multiple-category',
                    component: () => import('./views/user-pages/homework/Category.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'multiple-category'
                    }
                },
                {
                    path: '/user/multiple-topic-set',
                    name: 'multiple-topic-set',
                    component: () => import('./views/user-pages/homework/TopicSet.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'multiple-topic-set'
                    }
                },
                {
                    path: '/user/multiple-topic-set-question',
                    name: 'multiple-topic-set-question',
                    component: () => import('./views/user-pages/homework/QuestionInfo.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'multiple-topic-set'
                    }
                },
                {
                    path: '/user/multiple-choice-question-exercises-info',
                    name: '/multiple-choice-question-exercises-info',
                    component: () => import('./views/user-pages/homework/MultipleChoiceExercisInfo.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'multiple-choice-exercises'
                    }
                },
            ],

        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/active',
                    name: 'page-active',
                    component: () => import('@/views/pages/register/Active.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/active-email',
                    name: 'page-active-email',
                    component: () => import('@/views/pages/register/ActiveEmail.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                },

                //============Common page========
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }
    document.querySelectorAll('body > div.vs-component').forEach(el => {
        el.remove()
    })
    document.querySelectorAll('body > div.vs-content-sidebar').forEach(el => {
        el.remove()
    })
});

export default router
